import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  NgZone,
  OnInit,
  ViewEncapsulation,
} from "@angular/core";
import { FormGroup, FormBuilder } from "@angular/forms";
import { ActivatedRoute, Router } from "@angular/router";
import { ClassTemplate } from "app/shared/models/classTemplate.model";
import { ApiService } from "app/shared/services/api.service";
import { NgxSpinnerService } from "ngx-spinner";
import { ToastrService } from "ngx-toastr";

@Component({
  selector: "app-add-update-classtemplate",
  templateUrl: "./add-update-classtemplate.component.html",
  styleUrls: ["./add-update-classtemplate.component.scss"],
  encapsulation: ViewEncapsulation.None,
})
export class AddUpdateClasstemplateComponent implements OnInit {
  classTemplateForm: FormGroup;
  class_temp_model = new ClassTemplate();

  course_list = [];
  select_course = null;

  topic_list = [];
  select_topic = [];

  currentUrl: any;
  class_template_id: any;
  user: any;
  isEdit: boolean = false;
  sections: any = [];
  operating_system: any;
  isLmsContent: boolean;
  isSideBarHidden: boolean;
  activeCourseName: string = "";
  activeSectionName: string = "";
  activeChapterName: string = "";
  activeTopicName: string = "";
  activeSectionId: string = "";
  activeChapterId: string = "";
  activeTopicId: string = "";
  appsByTopic: any[] = [];
  isReadMode: boolean = false;
  selectedTopics: any = [];
  topicId: any;
  constructor(
    private formBuilder: FormBuilder,
    public toastr: ToastrService,
    private activatedRoute: ActivatedRoute,
    public apiService: ApiService,
    private route: Router,
    private spinner: NgxSpinnerService,
    private cdr: ChangeDetectorRef,
    private ngZone: NgZone
  ) {}

  ngOnInit(): void {
    this.activatedRoute.queryParams.subscribe(async (params: any) => {
      if (params.courseId) {
        this.select_course = params.courseId;
        this.getSectionsByCourse(this.select_course);
      }
      if (params.id) {
        this.isEdit = true;
        this.class_template_id = params.id;
        this.getClassTEmplateById(this.class_template_id);
      }
    });
    this.classTemplateForm = this.formBuilder.group({
      title: [""],
      admin_notes: [""],
    });
    this.getCourseList();
  }
  get rf() {
    return this.classTemplateForm.controls;
  }

  getClassTEmplateById(id) {
    if (id) {
      this.spinner.show(undefined, {
        type: "ball-triangle-path",
        size: "medium",
        bdColor: "rgba(0, 0, 0, 0.8)",
        color: "#fff",
        fullScreen: true,
      });
      this.apiService.getClassTemplate(id).subscribe((res: any) => {
        this.spinner.hide();
        this.class_temp_model = res?.data[0];
        this.select_course = this.class_temp_model.course_id[0]._id;
        this.getTopicList(this.select_course);
        this.getSectionsByCourse(this.select_course);
        this.select_topic = this.class_temp_model.topic_id.map(
          (item) => item._id
        );
      });
    }
  }

  getCourseList() {
    this.apiService.getCourseList(1, 100).subscribe((res: any) => {
      this.course_list = res?.data?.items;
    });
  }
  getCourseId(event) {
    this.getTopicList(this.select_course);
    this.getSectionsByCourse(this.select_course);
  }

  getTopicId(event) {
    this.select_topic;
  }
  getTopicList(id) {
    this.apiService.getTopicsByCourseId(id).subscribe((res: any) => {
      if (res.statusCode === 200) {
        const extractedData = res?.data.map((item) => {
          return item.data.flatMap((subArray) => {
            return subArray.flatMap((innerArray) => {
              return innerArray.map((obj) => {
                return {
                  name: obj.name,
                  _id: obj._id,
                };
              });
            });
          });
        });
        this.topic_list = extractedData.flat();
      }
    });
  }
  submit() {
    this.spinner.show(undefined,
      {
        type: 'ball-triangle-path',
        size: 'medium',
        bdColor: 'rgba(0, 0, 0, 0.8)',
        color: '#fff',
        fullScreen: true
      });
    this.class_temp_model.title = this.classTemplateForm.value.title;
    this.class_temp_model.admin_notes = this.classTemplateForm.value.admin_notes;
    this.class_temp_model.course_id = this.select_course;
    this.class_temp_model.topic_id = this.sections
    .flatMap(section => section.chapters.flatMap(chapter => chapter.topics)) // Flatten topics
    .filter(topic => topic.checked) // Filter checked topics
    .map(topic => topic._id); // Map to get _id values
    if (!this.isEdit) {
       this.apiService.addClassTemplate(this.class_temp_model).subscribe((res: any) => {
         if (res.statusCode === 200) {
          this.spinner.hide()
          this.toastr.success(res.message);
          this.route.navigate(["/classes/sessions"]);
        } else {
          this.toastr.error(res.error);
        }
      });
    }
    if (this.isEdit) {
      this.apiService
        .updateClassTemplate(this.class_temp_model)
        .subscribe((res: any) => {
          if (res.statusCode === 200) {
            this.spinner.hide();
            this.toastr.success(res.message);
            this.route.navigate(["/classes/sessions"]);
          } else {
            this.toastr.error(res.error);
          }
        });
    }
  }
  back() {
    this.route.navigate(["/classes/sessions"]);
  }
  isDivVisible: boolean = true;

  toggleVisibility() {
    this.select_course = !this.select_course;
    if (
      this.operating_system === "Windows" ||
      this.operating_system === "Mac"
    ) {
      this.isDivVisible = !this.isDivVisible;
    }
    if (
      this.operating_system === "Android" ||
      this.operating_system === "iOS"
    ) {
      this.isSideBarHidden = false;
      this.isDivVisible = true;
      if (this.isLmsContent === true) {
        this.isLmsContent = false;
      }
      if (this.isLmsContent === false) {
        this.isLmsContent = true;
      }
    }
  }
  getSectionsByCourse(id, studentId?) {
    this.spinner.show(undefined, {
      type: "ball-triangle-path",
      size: "medium",
      bdColor: "rgba(0, 0, 0, 0.8)",
      color: "#fff",
      fullScreen: true,
    });
    this.apiService.getSectionsByCourse(id, studentId).subscribe((res: any) => {
      if (res.isSuccess) {
        this.spinner.hide();
        this.sections = res?.data?.sections;
// Iterate through sections and update checked state based on class_temp_model.topic_id
this.sections.forEach(section => {
  section.chapters.forEach(chapter => {
    chapter.topics.forEach(topic => {
      // Check if topic._id exists in class_temp_model.topic_id using findIndex
      if (this.class_temp_model.topic_id) {
        const index = this.class_temp_model.topic_id.findIndex(el => el._id === topic._id);
      if (index !== -1) {
        topic.checked = true;
        chapter.checked = chapter.topics.every(topic => topic.checked);
        section.checked = section.chapters.every(chapter => chapter.checked);
      }
      }
      
    });

  });
});

      }
    });
  }

  activeBreadcrumb(
    sectionName?,
    sectionId?,
    chapterName?,
    chapterId?,
    topicName?,
    topicId?
  ) {
    (this.activeSectionName = sectionName),
      (this.activeChapterName = chapterName),
      (this.activeTopicName = topicName);
    (this.activeSectionId = sectionId),
      (this.activeChapterId = chapterId),
      (this.activeTopicId = topicId);
  }
  sectionSelection(e: any, sectionIndx: number) {
    const section = this.sections[sectionIndx];
    section.checked = e.target.checked;
    section.chapters.forEach(chapter => {
      chapter.checked = section.checked;
      chapter.topics.forEach(topic => {
        topic.checked = section.checked;
      });
    });
  }
  
  chapterSelection(e,sectionIndx: number, chapterIndx: number) {
    const chapter = this.sections[sectionIndx].chapters[chapterIndx];
    chapter.checked = e.target.checked;
    chapter.topics.forEach(topic => {
      topic.checked = chapter.checked;
    });
    this.sections[sectionIndx].checked = this.sections[sectionIndx].chapters.every(chapter => chapter.checked);
  }
  
  topicSelection(e,sectionIndx: number, chapterIndx: number, topicIndx: number) {
    const topic = this.sections[sectionIndx].chapters[chapterIndx].topics[topicIndx];
    topic.checked = e.target.checked;
    const chapter = this.sections[sectionIndx].chapters[chapterIndx];
    chapter.checked = chapter.topics.every(topic => topic.checked);
    this.sections[sectionIndx].checked = this.sections[sectionIndx].chapters.every(chapter => chapter.checked);
  }     
}
